import { Component, Fragment } from 'react';
import styled from 'styled-components';

import { pcVisitedLink } from '../../../../../common/css/setting/mixin';
import ModuleTitle from '../modules/ModuleTitle';
import {
  HeaderStyle,
  HeadingStyle,
  HeadingTitleStyle,
  SportsNavStyle,
  SportsNavItemStyle,
  SportsBodyStyle
} from './sportsCommonStyle';
import HorseRacingRace from './HorseRacingRace';

interface IProps {
  gradePickup: {
    isShow: boolean;
    races?: Array<{
      grade: string;
      date: string;
      raceNum: string;
      url: string;
      raceTitle: string;
      status: string;
    }>;
  };

  hasTitle: boolean; // モジュールタイトルを表示
}

const Header = styled.div<{ $hasTitle: boolean }>`
  ${HeaderStyle}
`;

const Heading = styled.div`
  ${HeadingStyle}
`;

const HeadingTitle = styled.div`
  ${HeadingTitleStyle}
`;

const NavList = styled.ul`
  ${SportsNavStyle}
`;

const NavItem = styled.li`
  ${SportsNavItemStyle}
`;

const NavLink = styled.a`
  ${pcVisitedLink}
`;

const Body = styled.div`
  ${SportsBodyStyle}
`;

export default class HorseRacing extends Component<IProps> {
  /**
   *
   */
  public render() {
    if (!this.props.gradePickup.isShow) {
      return null;
    }
    const header = (
      <Header $hasTitle={this.props.hasTitle}>
        <Heading>
          <HeadingTitle>スポーツナビ 重賞ピックアップ</HeadingTitle>
        </Heading>
        <NavList>
          <NavItem>
            <NavLink href="https://sports.yahoo.co.jp/keiba/" data-cl-params="_cl_vmodule:hrace;_cl_link:ysports;">
              競馬トップ
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              href="https://sports.yahoo.co.jp/keiba/schedule/monthly/"
              data-cl-params="_cl_vmodule:hrace;_cl_link:sche;"
            >
              日程・結果
            </NavLink>
          </NavItem>
        </NavList>
      </Header>
    );
    const body = (
      <Body>
        {this.props.gradePickup.races
          ? this.props.gradePickup.races.map((race, index) => {
              return (
                <HorseRacingRace
                  {...race}
                  key={race.url}
                  dataClParams={`_cl_vmodule:hrace;_cl_link:race;_cl_position:${index + 1};`}
                />
              );
            })
          : null}
      </Body>
    );

    return (
      <Fragment>
        {this.props.hasTitle ? <ModuleTitle titleText="競馬情報" hasPayPay={false} /> : ``}
        {header}
        {body}
      </Fragment>
    );
  }
}
